import React, { useEffect, useMemo, useState } from "react";
import {outletLedgerMetadata} from "./OutletLedgerUtils";
import "./outletLedger.css";
import { Loader } from "../../../components/loader/Loader";
import CustomDataGrid from "../../../components/dms_common/CustomDataGrid";
import Header from "../../../components/dms_common/Header";
import { useNavigate } from "react-router-dom";
import ScreenOverlay from "../../../components/dms_common/ScreenOverlay";
import { logAnalyticsEvent, logLoadTrace } from "../../../firebase";
import { fetchOutletLedgerData } from "./outletLedgerService";
import { openPopup } from "../../../stateManagement/actions/popupActions";
import { OutletLedgerData } from "../../../types/types";

const OutletLedger = () => {
    const navigate = useNavigate();
    const [allData, setAllData] = useState<OutletLedgerData[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchedValue, setSearchedValue] = useState<string>("");

    const handleSearchValueChange = (newValue: string) => {
        setSearchedValue(newValue);
    };

    const filteredData = useMemo(() => {
        return allData.filter((data) => {
            if(!searchedValue) return true;
            return (
                data.outletName?.toLowerCase().includes(searchedValue.toLowerCase()) ||
                data.outletCode?.toLowerCase().includes(searchedValue.toLowerCase())
            );
        });
    }, [searchedValue, allData]);


    const getInitialTableData = async () => {
        setIsLoading(true);
        try {
            const tempData = await fetchOutletLedgerData();
            setAllData(tempData);
            logAnalyticsEvent("outlet_ledger_page_viewed", {
                "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
                "total_outlets_displayed": tempData.length
            });
        } catch (error) {
            setAllData([]);
            logAnalyticsEvent("outlet_ledger_page_viewed", {
                "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
                "total_outlets_displayed": 0
            });
            openPopup("Error","Error while fetching outlet ledger data");
        }
        setIsLoading(false);
    };

    useEffect(() => {
        logLoadTrace(getInitialTableData, "outlet_ledger_page_load_time");
    }, []);

    const handleRedirect = (redirectUrl: string, rowData: OutletLedgerData) => {
        if (!rowData || !rowData.outletCode) return;
        navigate(`details`, {
            state: {
                outletCode: rowData.outletCode,
                outletName: rowData.outletName,
                createdOn: rowData.createdOn,
                creditAmount: rowData.creditAmount,
                lastBilledDate: rowData.lastBilledDate,
                lastPaymentDate: rowData.lastPaymentDate,
            },
        });
    };

    return (
        <div className="outlet-ledger-container">
            <Header
                title={"Outlet Ledger"}
                searchFunction={handleSearchValueChange}
                onRefresh={getInitialTableData}
            />
            {isLoading ? 
                <Loader sx={{ position: "absolute", top: "45%" }} />
             : 
                <CustomDataGrid
                    searchedValue={searchedValue}
                    rows={filteredData}
                    columnsMetaData={outletLedgerMetadata}
                    tableWidth={0.75}
                    showShelfLifeFooter={false}
                    noDataMessage="No Ledger data found."
                    redirectUrl="outletLedger"
                    redirectUrlFunction={handleRedirect}
                    orderStatusConfig={undefined}
                />
            }
        </div>
    );
};

export default OutletLedger;


